import styled from '@emotion/styled';

export const GoBack = styled.button`
  background-color: transparent;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 1rem;
  padding: 0.5rem 0;
`;
